export default __webpack_public_path__ + "static/media/jobs-value-design-for-joy.5199b043.svg";